import config from './config';
import deriveErrorCode from './deriveErrorCode';
import getPWADisplayMode from './getPWADisplayMode';
import simplifyUserAgent from './simplifyUserAgent';

let lastReportTime = 0;

// Firefox raises this from react-dom's window.event read when the event's document is already gone
const ignoredMessages = ['can\'t access dead object'];

/**
 * Report an unhandled crash to the backend.
 * Derives the error code from the stack trace, throttles to one report per 10s.
 * Fire-and-forget: never throws, never blocks the app.
 *
 * @param {Error|string} error
 */
const reportCrash = (error) => {
  try {
    const message = (typeof error === 'string') ? error : (error?.message || undefined);
    if (message && ignoredMessages.includes(message)) return;

    const now = Date.now();
    if ((now - lastReportTime) < 10000) return;
    lastReportTime = now;

    const code = deriveErrorCode(error);
    if (code === 'unknown') return;

    const webApp = getPWADisplayMode();
    const payload = {
      code: code.slice(0, 100),
      info: {
        rev: config.rev,
        url: window.location.href,
        userAgent: simplifyUserAgent(),
        ...((webApp !== 'browser') && { webApp }),
      },
    };

    if (message) payload.info.message = message;

    const url = `${config.town.back.urlPrefix}logs/internal/new`;

    fetch(
      url,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      },
    ).catch(() => {});
  } catch {
    // Never let error reporting break the app
  }
};

export default reportCrash;
